import { motion } from "framer-motion";
import { MessageCircle, Mail, Github } from "lucide-react";
import { useLang } from "../context/LangContext";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 },
};

export default function Contact() {
  const { t } = useLang();

  const links = [
    {
      icon: <MessageCircle size={18} />,
      label: t.contact.whatsapp,
      href: "https://wa.me/5534998651977",
      testid: "contact-whatsapp",
    },
    {
      icon: <Mail size={18} />,
      label: t.contact.email,
      href: "mailto:pedrolucasgag@gmail.com",
      testid: "contact-email",
    },
    {
      icon: <Github size={18} />,
      label: t.contact.github,
      href: "https://github.com/PiresLab",
      testid: "contact-github",
    },
  ];

  return (
    <section id="contact" data-testid="contact-section" className="py-24 md:py-32 bg-background">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.h2
          {...fadeUp}
          className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground mb-4"
        >
          {t.contact.title}
        </motion.h2>

        <motion.p
          {...fadeUp}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-base text-muted-foreground mb-10 max-w-xl leading-relaxed"
        >
          {t.contact.sub}
        </motion.p>

        <motion.div
          initial="initial"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            initial: {},
            visible: { transition: { staggerChildren: 0.08, delayChildren: 0.2 } },
          }}
          className="flex flex-col sm:flex-row items-start gap-3"
        >
          {links.map((l) => (
            <motion.a
              key={l.testid}
              variants={{
                initial: { opacity: 0, y: 12 },
                visible: { opacity: 1, y: 0 },
              }}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={l.testid}
              className="inline-flex items-center gap-2 border border-border text-foreground font-medium px-5 py-2.5 rounded-md hover:bg-secondary active:scale-[0.98] transition-all duration-200 text-sm w-full sm:w-auto justify-center"
            >
              {l.icon}
              {l.label}
            </motion.a>
          ))}
        </motion.div>

        <motion.p
          {...fadeUp}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-8 text-sm text-muted-foreground font-mono"
        >
          pedrolucasgag@gmail.com
        </motion.p>
      </div>
    </section>
  );
}
